module.exports = __webpack_public_path__ + "static/img/liantong.2a3408d5.png";